module.exports = __webpack_public_path__ + "img/shield.bd42973b.svg";